import styles from "./styles.module.scss";
import primaryComponents from "../../../../primaryComponents";
import { ProductTable } from "../ProductTable";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { PlusCircle } from "../../../../../assets/svgIcons";
import { useEffect } from "react";

export const ProductSelection = ({
  bulkForm,
  setBulkForm = () => {},
  ...validationParams
}) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = validationParams;

  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const addProductData = () => {
    const newData = {
      id: uuidv4(),
      name: "",
      category: "",
      department: "",
      payment_method: "",
      amount: "",
      vat_rate: 7.5,
      expense_date: "",
      description: "",
      bank_code: "",
      account_number: "",
    };

    setBulkForm((prevState) => ({
      ...prevState,
      expenses: [newData, ...prevState?.expenses],
    }));

    setValue("expenses", [newData, ...bulkForm?.expenses]);
  };

  useEffect(() => {
    if (bulkForm?.store_ids?.length > 0 && bulkForm?.expenses?.length === 0)
      addProductData();
  }, [bulkForm?.store_ids?.length]);

  return (
    <div className={styles.productSelection}>
      <div className="d-flex align-items-start justify-content-between flex-wrap">
        <div>
          <p className="dark--text">
            <span className="error--text">*</span>Select Store
          </p>
          <p className="smallest-text-size">
            Select the store where these expenses will be reviewed & approved
          </p>
        </div>
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <primaryComponents.MultipleSelectFieldV2
            control={control}
            name={"store_ids"}
            options={storeList}
            idKey="id"
            nameKey="name"
            errorMessage={errors?.store_ids}
            onChange={(values) => {
              const ids = values?.map((v) => v.value) || [];
              setBulkForm((prevState) => ({
                ...prevState,
                store_ids: ids,
              }));
            }}
          />
        </div>
      </div>

      <ProductTable
        bulkForm={bulkForm}
        setBulkForm={setBulkForm}
        setValue={setValue}
        {...validationParams}
      />

      <primaryComponents.Button
        classNames={"btn btn--outline cover"}
        type="button"
        onClick={() => {
          addProductData();
        }}
      >
        <PlusCircle className="mr-2" />
        Add another expense
      </primaryComponents.Button>
    </div>
  );
};
